import type { QuoteFile, PresentationLibrary } from 'paintscout'
import union from 'lodash/union'
import { getLibraryFileKey } from './get-library-file-key'

export const addFilesToLibrary = (args: { files: QuoteFile[]; library: PresentationLibrary }) => {
  const { files, library } = args
  const keys = files.map(getLibraryFileKey).filter(Boolean)

  if (files.length !== keys.length) {
    console.log('Missing Key: Library is for s3/cloudinary items only')
    return null
  }

  const updatedValues = { ...library?.values }
  keys.forEach((key) => {
    updatedValues[key] = { file: files.find((file) => getLibraryFileKey(file) === key) }
  })
  const updatedLibrary: PresentationLibrary = {
    values: updatedValues,
    order: union(keys, library?.order)
  }
  return updatedLibrary
}
